import src from "IMAGE";
export default { src, width: 470, height: 52, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ANHLyfjPycf4ysnS+MHBxvCPalrie21u6ce+u+nVzc3pmIkYP3k9TFkAAAAASUVORK5CYII="};
